class CounterModel {

    counterId?: number;
    name?: string;
    isActive?:boolean;
    zoneId?: number;
    zoneName?: string;
    acCode?:string;
    isCashCollection?:boolean;
}
export default CounterModel;